import { IconSvg, IconSvgProps } from "./icon"

export default function Search(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M10.67 17.342A6.67 6.67 0 1 0 10.67 4a6.67 6.67 0 0 0 0 13.342ZM20 20l-4.615-4.615" />
    </IconSvg>
  )
}
